import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  isInContext,
  onComplete,
  closeWindow,
} from '../utility/inContextDonation';
import _get from 'lodash/get';
import ConfirmationReturnText from './ConfirmationReturnText';

function ConfirmationInContext(props) {
  useEffect(() => {
    if (isInContext()) {
      const postBackData = props.postBackData;
      const status = _get(postBackData, 'isOfacPending')
        ? 'SUCCESS'
        : 'PENDING';

      onComplete({
        status,
        autoRedirectUrl: _get(props, 'autoRedirectUrl'),
        postBackData: _get(postBackData, 'postBackData'),
        syncReturnUrl: _get(postBackData, 'syncReturnUrl'),
      });
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      closeWindow();
    }, 5000);
  }, []);

  return <ConfirmationReturnText returnText={props.returnText} />;
}

ConfirmationInContext.propTypes = {
  postBackData: PropTypes.object,
  returnText: PropTypes.string,
};

export default ConfirmationInContext;
